import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAuth } from '../../../auth/AuthProvider';
import { archiveMachine, restoreMachine } from './machines.api';

function useLifecycleMutation(action: 'archive' | 'restore') {
  const auth = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (machineId: string) => action === 'archive' ? archiveMachine(machineId) : restoreMachine(machineId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['machines', auth.activeCustomerId] });
    },
  });
}

export function useArchiveMachine() {
  return useLifecycleMutation('archive');
}

export function useRestoreMachine() {
  return useLifecycleMutation('restore');
}
